import conf from '../common/config';
import func from '../common/function';

let es = {
  ep : {
    _stats : '_stats',
    _nodes : '_nodes',
    _template : '_template',
    nodes : {
      stats : '_nodes/stats',
      plugins : '_nodes/plugins',
      shutdown: node=>`_cluster/nodes/${encodeURIComponent(node)}/_shutdown`
    },
    cluster : {
      state : '_cluster/state',
      health : '_cluster/health'
    },
    indices : {
      stats: 'indices/stats',
      refresh : index=>encodeURIComponent(index)+'/_refresh',
      flush : index=>encodeURIComponent(index)+'/_flush',
      optimize : index=>encodeURIComponent(index)+'/_forcemerge',
      gatewaySnapshot : index=>encodeURIComponent(index)+'/_gateway/snapshot',
      analyser : index=>encodeURIComponent(index)+'/_analyze',
      open : index=>encodeURIComponent(index)+'/_open',
      close : index=>encodeURIComponent(index)+'/_close',
      delete : index=>encodeURIComponent(index)
    },
    alias : {
      add : '_aliases'
    },
    snapshot : {
      log : '_snapshot/LOGBACKUP',
      _all : '_snapshot/LOGBACKUP/_all',
      restore : snapshot=>`_snapshot/LOGBACKUP/${snapshot}/_restore`,
      delete : snapshot=>`_snapshot/LOGBACKUP/${snapshot}`
    }
  },
  request: function( params ) {
    return $.ajax( $.extend({
      url: conf.dbserver.get() + '/'+ params.path,
      contentType: "application/json",
      dataType: "json",
      "async": false,
      error: function(xhr, type, message) {
        if("console" in window) {
          console.log({ "XHR Error": type, "message": message });
        }
      },
      beforeSend : ()=>{
        func.loader.show();
      },
      complete : ()=>{
        func.loader.hide();
      }
    },  params) );
  },
  get: function(path, success, error) { return es.request( { type: "GET", path: path, success: success, error: error } ); },
  post: function(path, data, success, error) { return es.request( { type: "POST", path: path, data: data, success: success, error: error } ); },
  put: function(path, data, success, error) { return es.request( { type: "PUT", path: path, data: data, success: success, error: error } ); },
  delete: function(path, data, success, error) { return es.request( { type: "DELETE", path: path, data: data, success: success, error: error } ); }
}

export default es;


// WEBPACK FOOTER //
// ./src/scripts/data/es-api.js